var _path, _path2, _rect, _path3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSoftwareDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.46973,37.46973l-6,6a.74972.74972,0,0,0,0,1.06054l6,6,1.06054-1.06054L27.06055,44l5.46972-5.46973Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.53027,37.46973l-1.06054,1.06054L52.93945,44l-5.46972,5.46973,1.06054,1.06054,6-6a.74972.74972,0,0,0,0-1.06054Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.18399,
    y: 43.25015,
    width: 25.63201,
    height: 1.4997,
    transform: "translate(-15.24007 66.01216) rotate(-69.45269)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,16V64a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V16a.7502.7502,0,0,0-.75-.75H10A.7502.7502,0,0,0,9.25,16Zm1.5.75h58.5v6.5H10.75Zm0,8h58.5v38.5H10.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/icon_software_development.45b34bf359a7c5b191382f6cb5d4497e.svg";
export { ForwardRef as ReactComponent };